document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('da-form').addEventListener('submit', function (e) {
        e.preventDefault();

        const et = parseFloat(document.getElementById('da-et').value);
        const mph = parseFloat(document.getElementById('da-mph').value);
        const da = parseFloat(document.getElementById('da-da').value);

        if (isNaN(et) || isNaN(mph) || isNaN(da)) {
            alert("Please enter valid numbers.");
            return;
        }

        // Correction calculation
        const correctedEt = (et * 1.006 - (da * 0.00001 * et)).toFixed(2);
        const correctedMph = (mph * (0.9953 + 0.01 * (da / 1000))).toFixed(2);

        document.getElementById('da-your-et').textContent = `ET - ${et}`;
        document.getElementById('da-your-mph').textContent = `MPH - ${mph}`;
        document.getElementById('da-corrected-et').textContent = `ET - ${correctedEt}`;
        document.getElementById('da-corrected-mph').textContent = `MPH - ${correctedMph}`;

        document.getElementById('da-result').style.display = 'block';
    });
});